import React from 'react';
import { ConnectedLocationAutocomplete } from './LocationAutocomplete';
import { EntryPoint } from '../../models';

export function LocationAutocompleteSource({ departureOrArrival, activeProduct }) {
    const regexSpecialCharacters = activeProduct === EntryPoint.HOTELS ? /[!·*"();:@=+$,/?%#[\]]/g : /[!&·*"();:@=+$,/?%#[\]]/g;
    return {
        render: ({ onClickItem, displayedWord='', hasSelectedValue=false, isFixedWidth=false } = {}) => {
            const removeSpecialCharacters = (str) => str.replace(regexSpecialCharacters, '');
            return (
                <ConnectedLocationAutocomplete
                    key="location-autocomplete"
                    departureOrArrival={departureOrArrival}
                    displayedWord={removeSpecialCharacters(displayedWord)}
                    hasSelectedValue={hasSelectedValue}
                    onClickItem={onClickItem}
                    isFixedWidth={isFixedWidth}
                />
            );
        },
    };
}
